var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"flex",on:{"click":_vm.showAllProducts}},[_c('h4',[_vm._v("SHOW ALL PRODUCTS")]),_c('img',{attrs:{"src":require("../../assets/Footer/footer_arrow.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }